import { BigNumberish, BigNumber } from 'ethers';
import capitalize from 'lodash/capitalize';
import { DROP } from 'components/common';
import padStart from 'lodash/padStart';

export function mintNumberToName(mintNumber: string | number, drop: DROP) {
  if (drop === DROP.futura) {
    return `Master # ${mintNumber}`;
  }
  
  mintNumber = `${mintNumber}`;
  mintNumber = mintNumber.length === 1 ? `0${mintNumber}` : mintNumber;
  const baseName = `${capitalize(drop)} LP ${mintNumber}`;

  return baseName;
}

export const getGenesisOriginalId = (tokenId: BigNumberish): BigNumber => {
  // all genesis token ids are 40 bits, with the first bit being the print flag,
  // and the remaining 39 being the 'seed' for the generation logic.
  // according to docs, javascript doesn't work great with bitwise operations over 32
  // bits, so use BigNumber to do this safely
  let binaryRepr = padStart(BigNumber.from(tokenId).toNumber().toString(2), 40, '0');

  if (binaryRepr.length > 40) {
    throw Error('Invalid token id, not valid for the genesis release');
  }

  const originalBinary = `0${binaryRepr.substring(1)}`;
  return BigNumber.from(parseInt(originalBinary, 2));
};

export const getEnigmaOriginalId = (tokenId: BigNumberish): BigNumber => {
  // least significant is the print flag
  let binaryRepr = padStart(BigNumber.from(tokenId).toNumber().toString(2), 56, '0');

  if (binaryRepr.length > 56) {
    throw Error('Invalid token id, not valid for the genesis release');
  }

  const originalBinary = `${binaryRepr.substring(0, binaryRepr.length - 1)}0`;
  return BigNumber.from(parseInt(originalBinary, 2));
};

export const tokenIdToOriginalId = (drop: DROP, tokenId: BigNumberish): BigNumber => {
  if (drop === DROP.genesis) {
    return getGenesisOriginalId(tokenId);
  } else if (drop === DROP.enigma) {
    return getEnigmaOriginalId(tokenId);
  } else if (drop === DROP.futura) {
    return BigNumber.from(tokenId);
  }

  throw Error('Drop not yet supported');
};

export const toHexSeed = (drop: DROP, tokenId: BigNumberish): string => {
  // force input to the original
  return tokenIdToOriginalId(drop, tokenId).toHexString();
};

export const tokenIdIsAnOriginal = (drop: DROP, tokenId: BigNumberish) => {
  const inputTokenId = BigNumber.from(tokenId);
  const originalTokenId = tokenIdToOriginalId(drop, tokenId);
  return inputTokenId.eq(originalTokenId);
};

export const getDropFromTokenId = (tokenId: BigNumberish) => {
  if (tokenId.toString().length <= 5) {
    return DROP.futura;
  }

  try {
    getGenesisOriginalId(tokenId);
    return DROP.genesis;
  } catch (e) {}

  try {
    getEnigmaOriginalId(tokenId);
    return DROP.enigma;
  } catch (e) {}

  throw Error('Drop not yet supported');
};
